import { APIService } from "@/services/api";
import { API } from "@/lib/api";
import {
  ReadPayrollDepartment,
  WritePayrollDepartment,
} from "@/types/payrollDepartment";

export const PayrollDepartmentsService = new APIService<
  ReadPayrollDepartment,
  WritePayrollDepartment
>(API.PayrollDepartments);
